import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BPMService } from '../services/bpm.service';
import { ProjectService } from '../services/project.service';
export const taskResolver: ResolveFn<any> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const taskName = route.params['task'];
    const bpmService = inject(BPMService);
    const projectService = inject(ProjectService);
    const messageService = inject(MessageService);
    try {
        const taskDef = await bpmService.fetchTaskByTaskName(projectService.fetchCurrentProject().projectId, taskName);
        localStorage.setItem('activeTask', JSON.stringify(taskDef));
        return true;
    } catch (e) {
        messageService.add({
            summary: 'Unable to fetch the task definition for ' + taskName,
            severity: 'error',
        });

        return false;
    }
};
